// extracted by mini-css-extract-plugin
export default {"modalOverlay":"LJ-z","modalContent":"MJ-z","header":"NJ-z","close":"OJ-z"};